import {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import ProductEditFormApprovedProduct from 'components/product/ProductEditFormApprovedProduct';
import ProductEditFormImpl from 'components/product/ProductEditFormImpl';
import { setSelectedCTid } from 'store/slice/AppSlice';
import RemarkListPage from 'components/remark/page/RemarkListPage';

export default function UpdateproductActionImpl(){
    const dispatch = useDispatch();
    const {productObj} = useSelector((state) => state.pharmaslice.productDashboard);

    useEffect(() => {
        dispatch(setSelectedCTid(''));
    }, []);

    return (
        <>
        <ProductEditFormImpl />
        {/* {productObj.id===undefined || productObj.id===null ? 
            <ProductEditFormImpl />
            :
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    sx={{ width: "100%", backgroundColor: 'secondary.100', borderRadius: 2, padding: 1 }}
                >
                    <Grid item lg={9} md={9} sm={9} xs={12}
                        sx={{
                            backgroundColor: 'white',
                            borderRadius: 2,
                        }}
                    >
                        <ProductEditFormImpl />
                    </Grid>
                    <Grid item lg={3} md={3} sm={3} xs={12}
                        sx={{
                            pl: { lg: 2, md: 2, sm: 2, xs: 0 },
                            pt: { lg: 0, md: 0, sm: 0, xs: 1 },
                        }}
                    >
                        <RemarkListPage />
                    </Grid>
                </Grid>
            
            } */}
        
        </>
    )
}